import { useContext } from 'react'
import {AppContext} from "../context/app"

export const useApp = () => useContext(AppContext)
